module.exports = __webpack_public_path__ + "fa-solid-900.297973a488f688271dd2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.woff2
// module id = ./src/assets/webfonts/fa-solid-900.woff2
// module chunks = styles